import * as React from 'react';

export default class Spinner extends React.Component<{}, {}>{
    render() {
        return <img style={{ width: "50%", marginLeft: "auto", marginRight: "auto", display: "block" }} src={new URL("../../img/spinner.gif", import.meta.url).href} />
    }
}